// @flow

export default (data: mixed) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

/* This method aims to remove the dash from international tracks */
export const processTrackName = (trackName: string): string =>
  trackName.replace(" - ", " ");
